// Legacy alias — creation goes to the v2 builder; only ?id= edits keep
// /automations/create (the shared edit modal).
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function CreatePathAlias() {
    const params = useLocalSearchParams();
    return <Redirect href={{ pathname: params.id ? '/automations/create' : '/automations/new', params }} />;
}
